var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-97.329 -339.33)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 489.78 494.72)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1483.3-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.44226 -6.9385)",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "pm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1473-557.09q0 0.40039-0.1562 0.75195-0.1465 0.35157-0.4102 0.61524-0.2539 0.2539-0.6054 0.41015-0.3516 0.14649-0.752 0.14649h-5.3613v4.1992h-1.9141v-14.6h1.9141v1.7578q0.029-0.37109 0.1953-0.68359 0.166-0.32227 0.4199-0.55664 0.2539-0.24414 0.586-0.38086 0.3418-0.13672 0.7226-0.13672h3.4375q0.4004 0 0.752 0.15625 0.3515 0.14648 0.6054 0.41015 0.2637 0.25391 0.4102 0.60547 0.1562 0.35157 0.1562 0.75196zm-1.9238 0v-6.5527h-5.3613v6.5527z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1461.6-563.64v8.4766h-1.9238v-8.4766h-4.4043v8.4766h-1.9141v-10.4h1.9141v1.8359q0.019-0.38086 0.1757-0.71289 0.1563-0.3418 0.4102-0.58594 0.2637-0.25391 0.6055-0.39063 0.3418-0.14648 0.7324-0.14648h2.4805q0.3808 0 0.7226 0.14648 0.3418 0.13672 0.6055 0.39063 0.2637 0.24414 0.4199 0.58594 0.166 0.33203 0.1758 0.71289 0.019-0.38086 0.166-0.71289 0.1563-0.3418 0.4102-0.58594 0.2636-0.25391 0.6054-0.39063 0.3418-0.14648 0.7325-0.14648h2.4804q0.4004 0 0.752 0.15625 0.3515 0.14648 0.6054 0.41015 0.2637 0.25391 0.4102 0.60547 0.1563 0.35157 0.1563 0.75196v8.4766h-1.9239v-8.4766z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/pm.48e6c2c6120514a565b0140cac8d5ad0.svg";
export { ForwardRef as ReactComponent };